/* eslint-disable */
import { BrandIconSpinner, Tab } from 'components';
import React, { useState, useEffect, forwardRef } from 'react';
import { EndStyle } from 'pages/home/Home.style';
import { NetworkTabStyle } from './Network.style';
import { useSelector, useDispatch } from 'react-redux';
import {
  getFollowersList,
  getFollowersRequest,
  getFollowersSuggestionsList,
  PostMessageReceive,
  getFollowRequest,
} from 'redux/features/ActivityPostSlice';
import FollowersRequest from './FollowersRequest';
import { useNavigate, useParams } from 'react-router-dom';
import { VirtuosoGrid } from 'react-virtuoso';
import { Notification } from 'components/CustomNotification';
import { ReactComponent as NoDataFound } from 'assert/images/Common/noDataFound.svg';
import useWindowDimensions from 'components/Dimention';
import clsx from 'clsx';
import { t } from 'i18next';
import { Helmet } from 'react-helmet';

const scrollDataSize = 10;

export default function Network() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { screenW } = useWindowDimensions();
  const { tabname } = useParams();

  const { getProfile } = useSelector((state) => state?.ProfileSlice);
  const { PostMessage } = useSelector((state) => state.PostActivitySlice);

  const [activeKey, setActiveKey] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingBtn, setIsLoadingBtn] = useState(false);
  const [listWithDrawID, setListWithDrawID] = useState([]);

  const [isHasMore, setIsHasMore] = useState(false);
  const [ActivityList, setActivityList] = useState([]);
  const [scrollData, setScrollData] = useState(0);

  const [followScrollData, setFollowScrollData] = useState(0);
  const [isFollowHasMore, setIsFollowHasMore] = useState(false);
  const [followActivityList, setFollowActivityList] = useState([]);
  const screenWidth = screenW || screen.availWidth;

  const gridComponents = {
    List: forwardRef(({ style, children, ...props }, ref) => (
      <div
        ref={ref}
        {...props}
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          ...style,
        }}
      >
        {children}
      </div>
    )),
    Item: ({ children, ...props }) => (
      <div
        {...props}
        style={{
          padding: screenWidth < 600 ? '0.4rem' : '0 0.8rem 0.8rem 0',
          width:
            screenWidth < 350 ? '100%' : screenWidth < 600 ? '50%' : '243px',
          display: 'flex',
          flex: 'none',
          alignContent: 'stretch',
          boxSizing: 'border-box',
        }}
      >
        {children}
      </div>
    ),
  };

  const tabValues = () => {
    if (tabname === 'suggestions') {
      return 0;
    } else if (tabname === 'follow-request') {
      return 1;
    } else if (tabname === 'follower') {
      return 2;
    } else if (tabname === 'following') {
      return 3;
    } else if (tabname === 'mute') {
      return 4;
    } else if (tabname === 'block') {
      return 5;
    } else {
      return 0;
    }
  };

  useEffect(() => {
    handleFetch();
    setActiveKey(tabValues());
  }, [tabname]);

  useEffect(() => {
    if (PostMessage?.status) {
      dispatch(PostMessageReceive(''));
      if (PostMessage?.type === 'FOLLOW') {
        setListWithDrawID([PostMessage?.data?.followerId, ...listWithDrawID]);
      } else if (
        PostMessage?.type === 'FOLLOW REQUEST' ||
        PostMessage?.type === 'REMOVE'
      ) {
        setActivityList(
          ActivityList.filter(
            (list) =>
              (list?.followerId || list?.followingPersonId) !==
              PostMessage?.data?.followerId
          )
        );
      } else if (
        PostMessage?.type === 'WITHDRAW' ||
        PostMessage?.type === 'UNFOLLOW'
      ) {
        if (activeKey === 1) {
          setFollowActivityList(
            followActivityList.filter(
              (list) => list?.followerId !== PostMessage?.data?.followerId
            )
          );
        } else if (activeKey === 3) {
          setActivityList(
            ActivityList.filter(
              (list) => list?.followerId !== PostMessage?.data?.followerId
            )
          );
        } else {
          setListWithDrawID(
            listWithDrawID.filter(
              (list) => list !== PostMessage?.data?.followerId
            )
          );
        }
      } else if (PostMessage?.type === 'MUTE') {
        const listIndex = ActivityList.findIndex(
          (list) => list?.followerId === PostMessage?.data?.followerId
        );
        ActivityList[listIndex].isMuted = PostMessage?.data?.isMuted;
        setActivityList(ActivityList);
      } else if (PostMessage?.type === 'BLOCK') {
        const listIndex = ActivityList.findIndex(
          (list) => list?.followerId === PostMessage?.data?.followerId
        );
        ActivityList[listIndex].isBlocked = PostMessage?.data?.isBlocked;
        setActivityList(ActivityList);
      }
      setIsLoadingBtn(false);
    } else if (!PostMessage?.status) {
      setIsLoadingBtn(false);
    }
  }, [PostMessage]);

  const handleFetchFollowList = () => {
    setIsLoading(true);
    dispatch(
      getFollowRequest(
        // loginResponse?.id,
        getProfile?.userId,
        followScrollData,
        scrollDataSize
      )
    )
      .then((res) => {
        const response = res?.data?.data;
        setIsFollowHasMore(response?.hasMore);
        response.rows.forEach((item) => {
          item.isForFollowRequest = true;
        });
        setFollowActivityList([...followActivityList, ...response.rows]);
        setFollowScrollData(followScrollData + 1);
        setIsLoading(false);
      })
      .catch(() => {
        Notification('warning', 'Something went wrong');
        setIsLoading(false);
      });
  };

  useEffect(() => {
    //  && isHasMore
    if (tabname === 'follow-request') {
      handleFetchFollowList();
    }
  }, [ActivityList?.length, tabname]);

  const handleFetch = () => {
    setIsLoading(true);
    if (tabname === 'suggestions' || tabname === 'follow-request') {
      dispatch(
        tabname === 'suggestions'
          ? getFollowersSuggestionsList(scrollData, scrollDataSize)
          : getFollowersRequest(
              // loginResponse?.id,
              getProfile?.userId,
              scrollData,
              scrollDataSize
            )
      )
        .then((res) => {
          const response = res?.data?.data || res?.data;
          setIsHasMore(response?.hasMore);
          setActivityList([...ActivityList, ...response.rows]);
          setScrollData(scrollData + 1);
          setIsLoading(false);
        })
        .catch(() => {
          Notification('warning', 'Something went wrong');
          setIsLoading(false);
        });
    } else {
      dispatch(
        getFollowersList(GetListType(tabValues()), scrollData, scrollDataSize)
      )
        .then((res) => {
          setIsHasMore(res.data?.data?.hasMore);
          setActivityList([...ActivityList, ...res.data?.data?.rows]);
          setScrollData(scrollData + 1);
          setIsLoading(false);
        })
        .catch(() => {
          Notification('warning', 'Something went wrong');
          setIsLoading(false);
        });
    }
  };

  const handleItemContent = (_, item) => {
    return (
      <FollowersRequest
        activeKey={tabValues()}
        item={item}
        listWithDrawID={listWithDrawID}
        handleSetLoading={setIsLoadingBtn}
        isLoadingBtn={isLoadingBtn}
      />
    );
  };

  const RenderContentItems = () => {
    const list = ActivityList;
    if (
      (list?.length > 0 && isHasMore) ||
      (followActivityList.length > 0 && isFollowHasMore)
    ) {
      gridComponents.Footer = () => (
        <EndStyle customPadding={'30px 0 50px'}>
          <span>* * *</span>
        </EndStyle>
      );
    } else if (gridComponents?.Footer) {
      delete gridComponents.Footer;
    }
    return (
      <>
        {!isLoading &&
          list?.length === 0 &&
          followActivityList?.length === 0 && (
            <div className="network-no-data-found">
              <NoDataFound />
              <div>{t('Network.NoData')}</div>
            </div>
          )}
        {list?.length === 0 &&
          followActivityList?.length === 0 &&
          isLoading && (
            <div className="loading-container">
              <BrandIconSpinner loading={true} />
            </div>
          )}
        {followActivityList?.length > 0 && list?.length > 0 && (
          <h3 className="list-title">Follower Request</h3>
        )}
        {list?.length > 0 && (
          <VirtuosoGrid
            increaseViewportBy={{ top: 2000, bottom: 2000 }}
            className="followCardContainer"
            useWindowScroll
            data={list ?? []}
            components={gridComponents}
            itemContent={(index, item) => handleItemContent(index, item)}
            endReached={isHasMore ? handleFetch : () => {}}
          />
        )}
        {followActivityList?.length > 0 && (
          <>
            <h3 className="follow-list-title">
              {t('Network.FollowingRequest')}
            </h3>
            <VirtuosoGrid
              increaseViewportBy={{ top: 2000, bottom: 2000 }}
              className="followCardContainer"
              useWindowScroll
              data={followActivityList ?? []}
              components={gridComponents}
              itemContent={(index, item) => handleItemContent(index, item)}
              endReached={isFollowHasMore ? handleFetchFollowList : () => {}}
            />
          </>
        )}
      </>
    );
  };

  const tablist = [
    {
      label: t('Network.Suggestions'),
      value: 0,
      content: RenderContentItems(),
    },
    {
      label: t('Network.FollowRequest'),
      value: 1,
      content: RenderContentItems(),
    },
    {
      label: t('Network.Followers'),
      value: 2,
      content: RenderContentItems(),
    },
    {
      label: t('Network.Following'),
      value: 3,
      content: RenderContentItems(),
    },
    {
      label: t('Network.Mute'),
      value: 4,
      content: RenderContentItems(),
    },
    {
      label: t('Network.Block'),
      value: 5,
      content: RenderContentItems(),
    },
  ];

  const GetListType = (type) => {
    switch (Number(type)) {
      case 0:
        return 'suggestions';
      case 1:
        return 'follow-request';
      case 2:
        return 'follower';
      case 3:
        return 'following';
      case 4:
        return 'mute';
      case 5:
        return 'block';
    }
  };

  const handleTabChangePath = (name) => {
    navigate(`../network/${GetListType(name)}`, { replace: true });
  };

  return (
    <>
      <Helmet>
        <title>
          {tabname === 'suggestions'
            ? 'Suggestions | WafyNet - Discover New Connections'
            : tabname === 'follow-request'
            ? 'Follow Requests | WafyNet - Manage Incoming Requests'
            : tabname === 'follower'
            ? 'Followers | WafyNet - People Following You'
            : tabname === 'following'
            ? 'Following | WafyNet - People You Follow'
            : tabname === 'mute'
            ? 'Muted Users | WafyNet - Manage Your Muted Connections'
            : tabname === 'block'
            ? 'Blocked Users | WafyNet - Manage Your Blocked List'
            : 'Network | WafyNet - Manage Your Connections'}
        </title>
        <meta
          name="description"
          content={
            tabname === 'suggestions'
              ? 'Find people you might know or want to connect with on WafyNet.'
              : tabname === 'follow-request'
              ? 'Manage and accept follow requests from other users on WafyNet.'
              : tabname === 'follower'
              ? 'View the list of users who follow you on WafyNet and connect.'
              : tabname === 'following'
              ? 'Manage the users you follow and stay updated with their activities.'
              : tabname === 'mute'
              ? 'See and manage users you have muted on WafyNet.'
              : tabname === 'block'
              ? 'View and manage users you have blocked on WafyNet.'
              : 'Connect, follow, mute, or block users to manage your WafyNet network.'
          }
        />
      </Helmet>
      <NetworkTabStyle
        className={clsx(
          (ActivityList?.length !== 0 || followActivityList?.length !== 0) &&
            'container-padding'
        )}
      >
        <Tab
          tabList={tablist}
          handleTabChange={(key) => {
            setActiveKey(key);
            handleTabChangePath(key);

            setScrollData(0);
            setIsHasMore(false);
            setListWithDrawID([]);
            setFollowScrollData(0);
            setIsFollowHasMore(false);

            setActivityList([]);
            setFollowActivityList([]);
          }}
          callbackTabIndex={tabValues}
          activeKey={activeKey}
          keyChange={true}
          tabCustomcss="networktab"
        />
      </NetworkTabStyle>
    </>
  );
}
